import useCheckWindowSize from "./useCheckWindowSize";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useIsTablet = () => useCheckWindowSize("tablet-1", "mobile-1");

export default useIsTablet;
